"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_firebase_1 = require("react-redux-firebase");
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var hooks_1 = require("containers/MyStack/hooks");
var Transactions_1 = __importDefault(require("containers/Transactions"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var TransactionWrapperModal_1 = require("./styles/TransactionWrapperModal");
var TransactionModal = function (_a) {
    var selectedItem = _a.selectedItem, props = __rest(_a, ["selectedItem"]);
    var transactions = (0, hooks_1.useSingleServiceData)(selectedItem, {}, {
        recommendations: true, otherTools: true, reviews: true,
    }).transactions;
    var isLoading = !(0, react_redux_firebase_1.isLoaded)(transactions);
    return ((0, jsx_runtime_1.jsx)(TransactionWrapperModal_1.TransactionWrapperModal, __assign({ label: "transactionSummary" }, props, { children: !(transactions === null || transactions === void 0 ? void 0 : transactions.length)
            ? (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, sx: { my: 2 } }, { children: isLoading ? (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, {}) : 'No transactions found' }))
            : (0, jsx_runtime_1.jsx)(Transactions_1.default, { serviceStat: selectedItem, transactions: transactions }) })));
};
exports.default = TransactionModal;
